export const EXPLORE_TEXT = {
  header: 'Learn how Gusto works',
  subheader:
    "Gusto's all-in-one platform puts the tools you need to hire, pay, and manage your team at your fingertips.",
};

export const WRAP_TEXT_PLAIN = {
  LEARNING_JOURNEY_TEXT_DEFAULT: {
    headerCopy: 'Learn how Gusto works',
    subheaderCopy:
      'Gusto’s all-in-one people platform puts the tools you need to hire, pay, and manage your team at your fingertips.',
    imageAltText: 'Happy employers using HR operating systems',
    primaryCTA: "Let's go →",
    leadFormHeaderCopy: 'Tell us a little about you.',
    leadFormSubheaderCopy:
      "We'll use this information to provide guided recommendations and relevant links.",
  },
};
